import { render, staticRenderFns } from "./StudentHeader.vue?vue&type=template&id=6bda855c&scoped=true&lang=pug&"
import script from "./StudentHeader.vue?vue&type=script&lang=ts&"
export * from "./StudentHeader.vue?vue&type=script&lang=ts&"
import style0 from "./StudentHeader.vue?vue&type=style&index=0&id=6bda855c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda855c",
  null
  
)

export default component.exports